import { Link } from "gatsby"
import React from "react"

export const HeaderLink = ({ label, link }) => {
  const is_partially_active = ({ isPartiallyCurrent }) => ({
    className: `navbar-item${isPartiallyCurrent ? " is-currently-active" : ""}`,
  })

  return (
    <Link to={link} getProps={is_partially_active}>
      <span className="header-link">{label}</span>
    </Link>
  )
}
